import { render, staticRenderFns } from "./DictTypeListTable.vue?vue&type=template&id=a8f9fa6c&scoped=true"
import script from "./DictTypeListTable.vue?vue&type=script&lang=js"
export * from "./DictTypeListTable.vue?vue&type=script&lang=js"
import style0 from "./DictTypeListTable.vue?vue&type=style&index=0&id=a8f9fa6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f9fa6c",
  null
  
)

export default component.exports